import React from "react";
import { Text } from "../../ui/text";
import { VStack } from "../../ui/vstack";

interface FilterSectionProps {
  title: string;
  children: React.ReactNode;
}

/** A titled group of filter controls in a filter drawer. */
export const FilterSection = ({ title, children }: FilterSectionProps) => (
  <VStack space="sm">
    <Text size="sm" bold className="text-typography-800">
      {title}
    </Text>
    {children}
  </VStack>
);

export default FilterSection;
